import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('equipment/list', { params });
  },
  async main(params: any) {
    return axios.get('equipment/main', { params });
  },
  async sub(params: any) {
    return axios.get('equipment/sub', { params });
  },
  async task(params: any) {
    return axios.get('equipment/task', { params })
  },
  async taskadd(params: any) {
    return axios.post('equipment/task-add', qs.stringify(params))
  },
  async taskedit(params: any) {
    return axios.post('equipment/task-edit', qs.stringify(params))
  },
  async taskdetail(params: any) {
    return axios.get('equipment/task-detail', { params })
  },
  async taskdelete(params: any) {
    return axios.post('equipment/task-delete', qs.stringify(params))
  },
  async salecounter(params: any) {
    return axios.get('equipment-sale-counter/list', { params })
  },
  async addsalecounter(params: any) {
    return axios.post('equipment-sale-counter/add', qs.stringify(params))
  },
  async editsalecounter(params: any) {
    return axios.post('equipment-sale-counter/edit', qs.stringify(params))
  },
  async getsalecounter(params: any) {
    return axios.get('equipment-sale-counter/detail', { params })
  },
  async deletesalecounter(params: any) {
    return axios.post('equipment-sale-counter/delete', qs.stringify(params))
  }
};
